<mat-label class="subHeading ">{{label}}</mat-label>

<input type="text" formControlName="payin_value" />